import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'
import { clsx } from 'clsx'

import CampaignFormDialog from './components/CampaignFormDialog'
import CampaignsTable from './components/CampaignsTable'
import styles from './CampaignsPage.module.scss'
import baseStyles from '@/pages/base.module.scss'

import { CampaignListItem } from '@/api/generated'
import { getPromoCampaigns } from '@/api/internal'
import { selectIsInternalAdmin } from '@/store/features/user/userSlice'

export const CAMPAIGNS_QUERY_KEY = ['promoCampaigns'] as const

const CampaignsPage = () => {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const [editingCampaign, setEditingCampaign] = useState<CampaignListItem | null>(null)
  const [isCreating, setIsCreating] = useState(false)

  const {
    data: campaigns = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: CAMPAIGNS_QUERY_KEY,
    queryFn: async () => {
      const campaignListResponse = await getPromoCampaigns(200, 0)
      return campaignListResponse.data.campaigns
    },
  })

  if (!isInternalAdmin) {
    return (
      <div className={styles.container}>
        <p>You are not authorized to access this page</p>
      </div>
    )
  }

  const handleDialogSave = () => {
    setIsCreating(false)
    setEditingCampaign(null)
  }

  return (
    <>
      <Helmet>
        <title>Wispr Flow | Campaigns</title>
      </Helmet>
      <div className={clsx(baseStyles.container, styles.container)}>
        <div className={clsx(baseStyles.tabTitle, baseStyles.pageTabTitle)}>
          <h6>Promo Campaigns</h6>
        </div>
        <div className={styles.content}>
          {error && <div className={styles.errorBanner}>Failed to load campaigns</div>}

          <CampaignsTable
            campaigns={campaigns}
            isLoading={isLoading}
            onEdit={(campaign: CampaignListItem) => setEditingCampaign(campaign)}
            onCreate={() => setIsCreating(true)}
          />

          <CampaignFormDialog
            isOpen={isCreating || !!editingCampaign}
            campaign={editingCampaign}
            onSave={handleDialogSave}
            onCancel={() => {
              setIsCreating(false)
              setEditingCampaign(null)
            }}
          />
        </div>
      </div>
    </>
  )
}

export default CampaignsPage
